import React from "react";
import { Redirect, useParams } from "react-router-dom";

// Web fallback for universal/app links of the form /l/:type/:id.
// When the mobile app isn't installed the link opens here; map each
// type to its web page so the flow degrades gracefully.
export default function DeepLinkRedirect() {
  const { type, id } = useParams();

  switch (type) {
    case "sf-alarm":
      return <Redirect to={`/stop-device-alarm-request?token=${encodeURIComponent(id)}`} />;
    default:
      return <Redirect to="/dashboard" />;
  }
}
